export default __webpack_public_path__ + "static/media/Tunic of Benevolence.2efefa28.jpg";